var React = require('react');

function SmileyPleasedLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24.02 40a14 14 0 01-12.94-8.62 1.002 1.002 0 011.85-.77 12 12 0 0022.15 0 1.002 1.002 0 111.85.77A14 14 0 0124.02 40z","key":0}),React.createElement("path",{"d":"M24 48a24 24 0 110-48 24 24 0 010 48zm0-46a22 22 0 100 44 22 22 0 000-44z","key":1}),React.createElement("path",{"d":"M16.5 21.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm15 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z","key":2})]);
}

SmileyPleasedLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = SmileyPleasedLight;

SmileyPleasedLight.default = SmileyPleasedLight;
